import colors from "../../../../../../Constants/colors";

export const selectBaseStyles = {
  backgroundColor: colors.extremeWhite,
  border: `1px solid ${colors.primaryBlue}`,
  borderRadius: "5px",
  // boxShadow: `0px 4px 12px ${colors.secondaryBlue}`,
  color: colors.extremeBlack,
  "& .MuiSelect-icon": {
    color: colors.extremeBlack,
  },
  "& .MuiInputBase-input": {
    color: colors.extremeBlack,
  },
  "& .Mui-focused .MuiInputLabel-root": {
    color: colors.extremeBlack,
  },
  "&:before, &:after": {
    border: `1px solid ${colors.primaryBlue}`,
  },
};

export const menuItemStyles = {
  backgroundColor: "transparent",
  color: colors.extremeWhite,
  fontWeight: "normal",
  "&:hover": {
    backgroundColor: colors.primaryBlue,
    color: colors.extremeWhite,
  },
  "&.Mui-selected": {
    backgroundColor: `${colors.secondaryBlue} !important`,
    color: `${colors.extremeWhite} !important`,
    "&:hover": {
      backgroundColor: `${colors.primaryBlue} !important`,
      color: `${colors.extremeWhite} !important`,
    },
  },
};

export const menuContainerStyles = {
  backgroundColor: colors.extremeBlue,
  // boxShadow: `0px 4px 12px ${colors.primaryBlue}`,
  opacity: 1,
  backdropFilter: "none",
};

export const textfieldLayout = {
  backgroundColor: colors.extremeWhite,
  borderRadius: "5px",
  // boxShadow: "0px 4px 12px var(--secondaryBlue)",
  "& .MuiInputBase-input": {
    color: colors.extremeBlack, // Ensure the text color inside the input is white
  },
  "& .MuiInputLabel-root.Mui-focused": {
    fontSize: "1.25rem",
    color: colors.extremeBlack,
  },
  "& .MuiInputLabel-root": {
    color: colors.extremeBlack,
  },
  border: `1px solid ${colors.primaryBlue}`,
};
export const btnStyles = {
  color: colors.extremeWhite,
  bgcolor: colors.primaryBlue,
  textTransform: "none",
  ":hover": {
    bgcolor: colors.secondaryBlue,
  },
  "&.Mui-disabled": {
    bgcolor: colors.darkGray, // Update this to your defined gray color
    color: colors.extremeWhite,
  },
};
